// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration for AuraKart - shared with partner portal
const firebaseConfig = {
  apiKey: "AIzaSyA9BK8VMqj3_yGgdnMCdVxnYvVfU2yI8EI",
  authDomain: "joy-aura.firebaseapp.com",
  projectId: "joy-aura",
  storageBucket: "joy-aura.firebasestorage.app",
  messagingSenderId: "1076135056195",
  appId: "1:1076135056195:web:02837d3763783db98555f6",
  measurementId: "G-K1YBNNWPYT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);

// Enable persistence for better UX
import { setPersistence, browserLocalPersistence } from 'firebase/auth';
setPersistence(auth, browserLocalPersistence);

export const storage = getStorage(app);

export default app;